import { render, staticRenderFns } from "./memberTable.vue?vue&type=template&id=8dd51966&scoped=true&"
import script from "./memberTable.vue?vue&type=script&lang=ts&"
export * from "./memberTable.vue?vue&type=script&lang=ts&"
import style0 from "./memberTable.vue?vue&type=style&index=0&id=8dd51966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd51966",
  null
  
)

export default component.exports